import { FunctionComponent } from 'react'
import Button from '~/components/Button'
import { TrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { Spinner } from '~/components/Spinner'
import styles from './LoadMoreFooter.module.css'

type Props = {
  loading: boolean
  onLoadMore: () => void
  trackingLabel: TrackingLabel
}

/** The footer of a paginated `SelectableOptionsPopover`: the way to the next page, or a spinner while it loads. */
export const LoadMoreFooter: FunctionComponent<Props> = ({ loading, onLoadMore, trackingLabel }) => (
  <div className={styles.footer}>
    {loading ? (
      <Spinner />
    ) : (
      <Button variant="tertiary" trackingLabel={trackingLabel} onClick={onLoadMore}>
        Load more
      </Button>
    )}
  </div>
)
